var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_778_7887)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.33333,
    cy: 14.6668,
    r: 9.33333,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3544 8.5831H17.021C16.9294 8.5831 16.8544 8.6581 16.8544 8.74977V9.74977C16.8544 9.84143 16.9294 9.91643 17.021 9.91643H22.3544C22.446 9.91643 22.521 9.84143 22.521 9.74977V8.74977C22.521 8.6581 22.446 8.5831 22.3544 8.5831ZM19.5627 11.4164H17.021C16.9294 11.4164 16.8544 11.4914 16.8544 11.5831V12.5831C16.8544 12.6748 16.9294 12.7498 17.021 12.7498H19.5627C19.6544 12.7498 19.7294 12.6748 19.7294 12.5831V11.5831C19.7294 11.4914 19.6544 11.4164 19.5627 11.4164ZM12.6106 6.71852H11.7085C11.5794 6.71852 11.4752 6.82269 11.4752 6.95185V12.1185C11.4752 12.1935 11.5106 12.2623 11.571 12.306L14.6731 14.5685C14.7773 14.6435 14.9231 14.6227 14.9981 14.5185L15.5335 13.7873V13.7852C15.6085 13.681 15.5856 13.5352 15.4815 13.4602L12.8419 11.5518V6.95185C12.844 6.82269 12.7377 6.71852 12.6106 6.71852Z",
    fill: "black",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4334 14.0393H18.2293C18.1126 14.0393 18.0022 14.0997 17.9397 14.1997C17.6751 14.6184 17.3668 15.0059 17.0126 15.3601C16.4022 15.9705 15.6918 16.4497 14.9022 16.783C14.0834 17.1289 13.2147 17.3039 12.3188 17.3039C11.4209 17.3039 10.5522 17.1289 9.73551 16.783C8.94593 16.4497 8.23551 15.9705 7.6251 15.3601C7.01468 14.7497 6.53551 14.0393 6.20218 13.2497C5.85635 12.433 5.68135 11.5643 5.68135 10.6664C5.68135 9.76844 5.85635 8.90178 6.20218 8.08302C6.53551 7.29344 7.01468 6.58303 7.6251 5.97261C8.23551 5.36219 8.94593 4.88302 9.73551 4.54969C10.5522 4.20386 11.423 4.02886 12.3188 4.02886C13.2168 4.02886 14.0855 4.20386 14.9022 4.54969C15.6918 4.88302 16.4022 5.36219 17.0126 5.97261C17.3668 6.32678 17.6751 6.71428 17.9397 7.13303C18.0022 7.23303 18.1126 7.29344 18.2293 7.29344H19.4334C19.5772 7.29344 19.6688 7.14344 19.6043 7.01636C18.2459 4.31427 15.4918 2.55802 12.4168 2.52261C7.91468 2.46636 4.1751 6.15178 4.16676 10.6497C4.15843 15.1559 7.81051 18.8122 12.3168 18.8122C15.4313 18.8122 18.2313 17.0497 19.6043 14.3164C19.6688 14.1893 19.5751 14.0393 19.4334 14.0393Z",
    fill: "black",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_778_7887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.befda4ae701ee7980ddd47bd13655d81.svg";
export { ForwardRef as ReactComponent };